import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { FormulaPage } from "@/features/onboarding/pages/formula-page";

export const Route = createFileRoute("/onboarding/_guarded/formula")({
	head: () => pageTitle("Formula"),
	component: FormulaPage,
});
